var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu__item"},[_c('div',{staticClass:"dropdown-menu__link",domProps:{"innerHTML":_vm._s(_vm.calcReason(_vm.request.comment))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }